<form [formGroup]="formGroup">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between">
    <div fxFlex="1 0 auto" fxLayoutAlign="start center" fxLayoutAlign.xs="center center">
      <mat-button-toggle-group
        (change)="onChangeInterval($event)">
        <mat-button-toggle *ngFor="let option of formGroup.intervalOptions"
                           [value]="option.value"
                           [checked]="formGroup.value.interval === option.value">
          {{option.option}}
        </mat-button-toggle>
      </mat-button-toggle-group>

    </div>
    <div fxFlex="0 0 auto" fxLayoutAlign="end center" fxLayoutAlign.xs="center center">
      <button (click)="onNavigate(-1)" [disabled]="!hasNextOption(-1)" mat-icon-button>
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <mat-form-field appearance="outline">
        <mat-select
          formControlName="date"
          placeholder="Keine Daten vorhanden"
          (valueChange)="onChangeDate($event)"
          [compareWith]="compareDate">
          <mat-option *ngFor="let option of formGroup.yearMonthOptions" [value]="option.value">
            {{option.option}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button (click)="onNavigate(1)" [disabled]="!hasNextOption(1)" mat-icon-button>
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>
</form>



<ng-content></ng-content>
